var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3427 17.477H35.0002V17.4078H20.0002V24.0745H29.4193C28.0452 27.9553 24.3527 30.7411 20.0002 30.7411C14.4777 30.7411 10.0002 26.2636 10.0002 20.7411C10.0002 15.2186 14.4777 10.7411 20.0002 10.7411C22.5493 10.7411 24.8685 11.7028 26.6343 13.2736L31.3485 8.55946C28.3718 5.7853 24.3902 4.07446 20.0002 4.07446C10.796 4.07446 3.3335 11.537 3.3335 20.7411C3.3335 29.9453 10.796 37.4078 20.0002 37.4078C29.2043 37.4078 36.6668 29.9453 36.6668 20.7411C36.6668 19.6236 36.5518 18.5328 36.3427 17.477Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25488 12.9836L10.7307 16.9995C12.2124 13.3311 15.8007 10.7411 19.9999 10.7411C22.5491 10.7411 24.8682 11.7028 26.6341 13.2736L31.3482 8.55946C28.3716 5.7853 24.3899 4.07446 19.9999 4.07446C13.5982 4.07446 8.04655 7.68863 5.25488 12.9836Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 37.4077C24.3051 37.4077 28.2168 35.7602 31.1743 33.081L26.0159 28.7161C24.2864 30.0314 22.173 30.7428 20.0001 30.7411C15.6651 30.7411 11.9843 27.9769 10.5976 24.1194L5.1626 28.3069C7.92093 33.7044 13.5226 37.4077 20.0001 37.4077Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3425 17.4769H35V17.4077H20V24.0744H29.4192C28.7618 25.9214 27.5778 27.5354 26.0133 28.7169L26.0158 28.7152L31.1742 33.0802C30.8092 33.4119 36.6667 29.0744 36.6667 20.741C36.6667 19.6235 36.5517 18.5327 36.3425 17.4769Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.d5d07c9d1b9f781f7dda7d643863383f.svg";
export { ForwardRef as ReactComponent };